import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { VoteCommentInfo } from '@mommy/models/VoteCommentInfo.model';
import { Api } from '@mommy/services/api';

@Injectable({
  providedIn: 'root',
})
export class MemberVoteCommentService {
  constructor(private api: Api) {}

  get_list(data?: any): Promise<any> {
    const endpoint = 'v1/member/member-vote-comment';

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.get(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-vote-comment list get error', error);
        reject(error);
      }
    });
  }

  delete(vote_comment_id: number): Promise<any> {
    const endpoint = `v1/member/member-vote-comment/comments/${vote_comment_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.delete(endpoint).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-vote-comment delete error', error);
        reject(error);
      }
    });
  }

  add(voteCommentInfo: VoteCommentInfo): Promise<any> {
    const endpoint = `v1/member/member-vote-comment/comments`;

    return new Promise(async (resolve, reject) => {
      try {
        let params: any = {};
        params = voteCommentInfo;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-vote-comment add error', error);
        reject(error);
      }
    });
  }

  update(voteCommentInfo: VoteCommentInfo): Promise<any> {
    const endpoint = `v1/member/member-vote-comment/comments/${voteCommentInfo.vote_comment_id}`;

    return new Promise(async (resolve, reject) => {
      try {
        const result: APIResponse = await (<any>(
          this.api.put(endpoint, voteCommentInfo).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-vote-comment update error', error);
        reject(error);
      }
    });
  }
}
